import React, { useEffect } from 'react';
import { useModalWatch } from '../../../shared/packages/modalManager';
import { modalNames } from '../../../shared/configs/modal';
import { useDeskNamesQuery } from '../../../api/desk';
import { useFieldController } from '../../../../../helpers/formManager';
import { fieldNames } from '../constants';
import Field from '../../../shared/ui/Field';

const emptyArr = [];

const name = fieldNames.deskName;

const NameField = ({ control, setIsChecking, setError }) => {
  const { props = {} } = useModalWatch({ name: modalNames.setDeskName });
  const { name: initialName = '', serviceCompanyId } = props;

  const {
    field: { value, onChange },
    fieldState: { isDirty, error: { type, message: errorMessage } = {} },
  } = useFieldController({
    control,
    name,
    defaultValue: initialName,
    rules: { validate: getValidate(initialName) },
  });

  const { data } = useDeskNamesQuery({ params: { serviceCompanyId } });
  const existingNames = !data || data === 'Error' ? emptyArr : data;

  // debounce проверка на существование имени
  useEffect(() => {
    if (type !== 'validate' && existingNames.length && isDirty) {
      setIsChecking(true);

      const timeoutId = setTimeout(() => {
        const exists = existingNames.some(({ name }) => name === value);

        if (exists) {
          setError(name, {
            type: 'exists',
            message: 'Стол с таким именем уже существует',
          });
        }

        setIsChecking(false);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
        setIsChecking(false);
      };
    }
  }, [value, type, setIsChecking, existingNames, setError, isDirty]);

  return (
    <Field.Memoized
      type={Field.types.input}
      formItemLabel="Наименование стола"
      required
      value={value}
      onChange={onChange}
      errorMessage={errorMessage}
    />
  );
};

export default NameField;

function getValidate(initialValue) {
  return (value) => {
    if (!value?.trim()) return 'Укажите наименование стола';

    if (initialValue && value === initialValue)
      return 'Наименование не изменено';

    return true;
  };
}
